import { render, staticRenderFns } from "./mailManage.vue?vue&type=template&id=9c7bc79c&scoped=true&"
import script from "./mailManage.vue?vue&type=script&lang=js&"
export * from "./mailManage.vue?vue&type=script&lang=js&"
import style0 from "./mailManage.vue?vue&type=style&index=0&id=9c7bc79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7bc79c",
  null
  
)

export default component.exports